module.exports = __webpack_public_path__ + "img/eye-transparent.e20a1421.svg";